import { Sparkles, Brain } from "lucide-react";
import { Reveal, LeafDivider } from "@/components/Reveal";

export const BrainSection = () => (
  <section id="brein" className="py-24 bg-brand-forest text-brand-cream relative overflow-hidden">
    <div className="absolute inset-0 grain opacity-40" />
    <div className="relative max-w-5xl mx-auto px-6 lg:px-10">
      <Reveal className="text-center">
        <span className="inline-flex items-center gap-2 eyebrow !text-brand-goldLight"><Brain size={16} /> Achtergrond</span>
        <h2 className="font-display text-4xl sm:text-5xl mt-3">Het kinderbrein & het volwassen brein</h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-8 mt-14">
        <Reveal delay={0.1}>
          <div className="rounded-2xl bg-white/5 border border-brand-goldLight/20 p-7 h-full">
            <h3 className="font-display text-2xl text-brand-goldLight">Het kinderbrein</h3>
            <p className="font-body text-brand-cream/85 mt-3 leading-relaxed">
              Het kinderbrein voelt, beleeft en reageert direct. Het zoekt veiligheid, verbinding en geborgenheid.
              Wanneer een kind zich onveilig voelt, ontstaan overlevingspatronen die we vaak ons hele leven met ons
              meedragen — als spanning, angst of het gevoel er niet te mogen zijn.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="rounded-2xl bg-white/5 border border-brand-goldLight/20 p-7 h-full">
            <h3 className="font-display text-2xl text-brand-goldLight">Het volwassen brein</h3>
            <p className="font-body text-brand-cream/85 mt-3 leading-relaxed">
              Het volwassen brein denkt, plant en analyseert. Het kan rust en overzicht bieden, maar staat soms
              ver af van wat we werkelijk voelen. Heling ontstaat wanneer het volwassen brein leert luisteren naar
              het kinderbrein — met geduld, mildheid en aandacht.
            </p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.3}>
        <div className="mt-10 text-center max-w-2xl mx-auto">
          <LeafDivider />
          <p className="font-body text-brand-cream/90 text-lg leading-relaxed">
            Wanneer gevoel en bewustzijn samenwerken, ontstaat veiligheid en ruimte om te worden wie je werkelijk bent.
            In onze workshops brengen we deze twee weer met elkaar in verbinding.
          </p>
          <p className="font-script text-brand-goldLight text-5xl mt-6 flex items-center justify-center gap-3">
            <Sparkles size={20} className="text-brand-goldLight" /> Voelen mag weer veilig zijn
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
